import { render, staticRenderFns } from "./NewPrevired.vue?vue&type=template&id=58ede18a&scoped=true&"
import script from "./NewPrevired.vue?vue&type=script&lang=ts&"
export * from "./NewPrevired.vue?vue&type=script&lang=ts&"
import style0 from "./NewPrevired.vue?vue&type=style&index=0&id=58ede18a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58ede18a",
  null
  
)

export default component.exports